function toRad(value: number) {
  return value * Math.PI / 180
}

const R = 6371 // Earth's radius in kilometers

/** Function to calculate the distance in KM between two points using the Haversine formula */
export default function calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number) {
  const dLat = toRad(lat2 - lat1)
  const dLon = toRad(lon2 - lon1)
  const latRad1 = toRad(lat1)
  const latRad2 = toRad(lat2)

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(latRad1) * Math.cos(latRad2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c
  return d
}
